import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { useEffect, useState } from 'react';

/**
 * Export button with a row-count slider (1..total, defaults to all rows).
 * `onExport` receives the chosen row limit.
 */
export function CsvExportControl({
  total,
  exporting,
  disabled = false,
  showLimitControl = true,
  buttonClassName = 'rdc-dashboard-details-button',
  onExport,
}: {
  total: number | null;
  exporting: boolean;
  disabled?: boolean;
  showLimitControl?: boolean;
  buttonClassName?: string;
  onExport: (limit: number) => void;
}) {
  // For chosenCount, null = "all rows"; an explicit choice is clamped to the current total.
  const [chosenCount, setChosenCount] = useState<number | null>(null);
  // A new result set (filter/chain change) invalidates the previous choice.
  useEffect(() => {
    setChosenCount(null);
  }, [total]);
  const effectiveCount = total === null ? 0 : Math.max(1, Math.min(chosenCount ?? total, total));
  const isDisabled = disabled || exporting || total === null || total === 0;
  const buttonLabel =
    total === null
      ? 'Export CSV (…)'
      : exporting
        ? 'Exporting...'
        : `Export CSV (${effectiveCount.toLocaleString('en-US')})`;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      {showLimitControl && total !== null && total > 1 ? (
        <input
          type="range"
          min={1}
          max={total}
          value={effectiveCount}
          aria-label="Rows to export"
          title="How many rows to export (dirtiest first)"
          disabled={isDisabled}
          style={{ width: 88 }}
          onChange={(event) => setChosenCount(Number(event.target.value))}
        />
      ) : null}
      <button
        type="button"
        className={buttonClassName}
        disabled={isDisabled}
        title="Download the rows matching the current filters with full details"
        onClick={() => {
          if (total !== null) onExport(effectiveCount);
        }}
      >
        <FileDownloadOutlinedIcon style={{ fontSize: 15 }} />
        {buttonLabel}
      </button>
    </span>
  );
}
